
import React, { Component } from 'react';
import { HorizontalBar } from 'react-chartjs-2';



export default class ClusteredBarChart extends Component {
  

      render() {
        const dualHorizontalBarsChartData = { 
            labels: this.props.label,
            datasets: [ 
                { 
                    label: this.props.label1,
                    backgroundColor: this.props.color,
                    data:this.props.data,
                    borderWidth: 0,
                },{
                    label: this.props.label2,
                    backgroundColor: this.props.color1,
                    data:this.props.data2,
                    borderWidth: 0,
                }
            ]
        }
        const  dualChartOptions = { 
                responsive: true ,
                maintainAspectRatio:false,
                barPercentage: 1,
                legend: {
                  display: false
                },
                scales: {
                  xAxes: [
                    {
                      ticks:{
                          min: 0,
                          stepSize:this.props.stepSize
                      }
                    }
                  ],
                  yAxes: [
                    {
                        display: this.props.isLabel
                    }
                  ]
                }
              }
        return <HorizontalBar data={dualHorizontalBarsChartData} options={dualChartOptions} />
      }
}